import { render, staticRenderFns } from "./TabLogo.vue?vue&type=template&id=68d3e7c8&"
import script from "./TabLogo.vue?vue&type=script&lang=js&"
export * from "./TabLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports